module.exports = __webpack_public_path__ + "img/m7.5be43d64.jpg";